import React from "react";
import styled, { withTheme } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";

const IconWrapper = styled.div`
  align-items: center;
  color: ${cloud.getShade(10)};
  display: flex;
  font-size: 3rem;
  font-weight: 700;
  justify-content: center;
  line-height: 35px;

  svg {
    margin-right: 4px;
  }
`;

const OffScreen = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

const BottomText = styled.div`
  color: ${cloud.getShade(7)};
  font-size: 1.2rem;
  letter-spacing: 0.3px;
  line-height: 14px;
  margin-top: 3px;
  text-align: center;
  text-transform: uppercase;
`;

const Item = ({ count, Icon, text, theme }) => {
  return (
    <li>
      <IconWrapper>
        {<Icon fill={theme.color.primary.getShade(7)} />}
        {count}
      </IconWrapper>
      <BottomText>
        {text}
      </BottomText>
    </li>
  );
};

export default withTheme(Item);
